export default __webpack_public_path__ + "static/media/easystore.a4027984.png";